import { fromJS } from 'immutable';
import { useMemo } from 'react';
import I18n from 'I18n';
import { WarningIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';

// @ts-expect-error untyped import
import FilterOperatorDisplay from 'customer-data-filters/components/operator/FilterOperatorDisplay';
import { fromObjectSegFilterStrict } from 'customer-data-filters/converters/objectSeg/fromObjectSegFilter';
import DSFieldRecord from 'customer-data-filters/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { getIsUngated, useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
// @ts-expect-error untyped import
import { useExpressionField } from '../SourceMeta';
import { buildSpecialOptionsByReferenceType
// @ts-expect-error untyped import
} from '../../xo-filter-utils';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpanContainer = styled.div.withConfig({
  displayName: "ExpressionFieldFilterLabel__StyledSpanContainer",
  componentId: "l38wfz-0"
})(["display:block;font-weight:600;margin-bottom:-4px;"]);
const getMappedProps = (filter, field, expressionField, userId, userGates) => {
  const {
    filter: fieldFilter
  } = filter;
  const getReferencedObjectType = () => null;
  const getFamilyValueResolver = () => null;
  const label = expressionField ? expressionField.label : '';
  const filterFamily = 'SNOWFLAKE';
  const operator = fieldFilter && fieldFilter.get('operation') ? fromObjectSegFilterStrict(fieldFilter.toJS(), () => DSFieldRecord(fromJS(Object.assign({
    label
  }, field))), filterFamily, gate => getIsUngated(gate, userGates), true) : undefined;
  return {
    currencyCode: 'USD',
    isReadOnly: true,
    isXoEnabled: true,
    operator,
    getSpecialOptionsForReferenceType: buildSpecialOptionsByReferenceType(field.type, userId),
    filterFamily,
    getLabelString: () => label,
    getReferencedObjectType,
    getFamilyValueResolver
  };
};
export const ExpressionFieldFilterLabel = ({
  filter,
  errorTooltipMessage
}) => {
  const {
    field
  } = filter;
  const {
    userId,
    userGates
  } = useFilterRelevantUserInfo();
  const expressionField = useExpressionField(field.name);
  const filterOperatorDisplayProps = useMemo(() => {
    return getMappedProps(filter, field, expressionField, userId, userGates);
  }, [filter, field, expressionField, userId, userGates]);
  const content = filterOperatorDisplayProps.operator ? /*#__PURE__*/_jsx(FilterOperatorDisplay, Object.assign({}, filterOperatorDisplayProps, {
    getIsUngated: gate => getIsUngated(gate, userGates)
  })) : /*#__PURE__*/_jsx(Text, {
    as: "strong",
    children: filterOperatorDisplayProps.getLabelString()
  });
  const isValid = !errorTooltipMessage;
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "expression-field-filter-label",
    children: [/*#__PURE__*/_jsx(StyledSpanContainer, {
      children: /*#__PURE__*/_jsxs(Text, {
        color: !isValid ? 'text-alert-default' : 'text-core-default',
        children: [I18n.text('reporting-snowflake.filter-editor.expression-field.label'), !isValid && /*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(WarningIcon, {
            alignWithText: true
          })
        })]
      })
    }), isValid ? content : /*#__PURE__*/_jsx(Tooltip, {
      title: errorTooltipMessage,
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-alert-default",
        children: content
      })
    })]
  });
};